export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7570.3104c5bd.jpg";